export enum ButtonType {
  SIMPLE = 'button',
  ROUND = 'button-round'
}
